import setConversationsFlagState from './setConversationsFlagState';
import { setItemsFlagStateFromTable } from './setItemsFlagState';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { ActionSource } from 'owa-analytics-actions';
import FlagType from 'owa-service/lib/contract/FlagType';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { MailRowDataPropertyGetter, getStore as getListViewStore } from 'owa-mail-list-store';

/**
 * set the mail list rows' flagged state
 * @param rowKeys the given rowkeys
 * @param tableViewId of the table that the row belong to
 * @param flagTypeToApply the flagType to apply
 * @param actionSource source of this action
 * @param override force service call to dispatch even if flagTypeToApply.flagStatus is the same
 */
export default function setMailListRowsFlagState(
    rowKeys: string[],
    tableViewId: string,
    flagTypeToApply: FlagType,
    actionSource: ActionSource,
    override?: boolean
) {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            setConversationsFlagState(
                rowKeys,
                instrumentationContexts,
                tableViewId,
                flagTypeToApply,
                actionSource,
                getFilteredRowKeysToPerformFlagAction,
                override
            );
            break;

        case ReactListViewType.Message:
            setItemsFlagStateFromTable(
                rowKeys,
                instrumentationContexts,
                tableViewId,
                flagTypeToApply,
                actionSource,
                getFilteredRowKeysToPerformFlagAction,
                override
            );
            break;
    }
}

function getFilteredRowKeysToPerformFlagAction(
    rowKeys: string[],
    tableViewId: string,
    flagTypeToApply: FlagType
) {
    const tableView = getListViewStore().tableViews.get(tableViewId);
    // Filter out the rows which has the same flag type as the new flag type
    const filteredRowKeys = rowKeys.filter(
        rowKey =>
            MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView) != flagTypeToApply.FlagStatus
    );

    return filteredRowKeys;
}
